import { useRef } from "react";
import { CheckCircle2, ExternalLink, Paperclip, X, Camera } from "lucide-react";
import { TierBadge } from "@/components/funding/TierBadge";

const OPTS = [["yes", "Yes"], ["no", "No"], ["unsure", "Not sure"]];

export function RequirementRow({ r, answer, proofName, onAnswer, onUpload, onClearProof, onScan }) {
  const file = useRef(null);
  const met = answer === "yes";
  return (
    <div className={`bg-white border rounded-lg p-4 ${met ? "border-emerald-200" : "border-slate-200"}`} data-testid={`req-${r.id}`}>
      <div className="flex flex-wrap items-center gap-2"><TierBadge tier={r.tier} />{met && <CheckCircle2 className="h-4 w-4 text-emerald-600" />}<span className="text-xs text-slate-400">{r.issuer}</span></div>
      <h4 className="font-semibold text-slate-900 mt-2">{r.title}</h4>
      <p className="text-sm text-slate-700 mt-1">{r.question}</p>
      <div className="mt-3 flex flex-wrap gap-2">
        {OPTS.map(([v, l]) => (
          <button key={v} onClick={() => onAnswer(r.id, v)} data-testid={`req-${r.id}-${v}`}
            className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${answer === v ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"}`}>{l}</button>
        ))}
      </div>
      {!met && !proofName && (
        <button onClick={() => onScan(r.id)} className="mt-3 inline-flex items-center gap-1 text-xs text-emerald-700 font-medium hover:underline" data-testid={`req-${r.id}-scan`}><Camera className="h-3 w-3" />Have it? Scan it with your camera</button>
      )}
      {met && (
        <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs">
          {proofName ? (
            <span className="inline-flex items-center gap-1 text-emerald-700" data-testid={`req-${r.id}-proof`}><Paperclip className="h-3 w-3" />Verified: {proofName}
              <button onClick={() => onClearProof(r.id)} aria-label="Remove proof" data-testid={`req-${r.id}-proof-remove`}><X className="h-3 w-3 text-slate-400" /></button></span>
          ) : (
            <>
              <input ref={file} type="file" className="hidden" onChange={(e) => e.target.files[0] && onUpload(r.id, e.target.files[0])} data-testid={`req-${r.id}-file`} />
              <button onClick={() => file.current.click()} className="inline-flex items-center gap-1 text-emerald-700 font-medium hover:underline" data-testid={`req-${r.id}-upload`}><Paperclip className="h-3 w-3" />Upload proof ({r.proof})</button>
              <button onClick={() => onScan(r.id)} className="inline-flex items-center gap-1 text-emerald-700 font-medium hover:underline" data-testid={`req-${r.id}-scan`}><Camera className="h-3 w-3" />Scan with camera</button>
            </>
          )}
        </div>
      )}
      {r.link && <a href={r.link} target="_blank" rel="noreferrer" className="mt-2 text-xs text-slate-500 inline-flex items-center gap-1 hover:underline"><ExternalLink className="h-3 w-3" />Official source</a>}
    </div>
  );
}
